import {
  React,
  Link,
  PropTypes,
  FaCalendarAlt
} from '../libraries'
import { CardImage } from './index'
import imgCard from '../assets/images/header-bg.jpg'
import { 
  Col,
  Card,
  Badge,
 } from 'react-bootstrap'

export const CardNews = ({ id, title, content, image, category, styleImg, url, eventStart, eventEnd, type }) => {
  return (
    <Col xs={12} className='mb-5'>
      <Link
        to={{
          pathname: `${url}`,
          id: id
        }}
      >
        <Card>
          <CardImage id={id} image={image} alt={title} styleImg={styleImg} />
          {type === 'event' ? (
            <Card.Body>
              <Card.Subtitle className='my-3 text-muted'>
                <FaCalendarAlt /> &nbsp {eventStart} - {eventEnd}
              </Card.Subtitle>
              <Card.Title>{title}</Card.Title>
              <Card.Text dangerouslySetInnerHTML={{ __html: content }} />
            </Card.Body>
          ) : (
            <Card.Body>
              <Card.Title>{title}</Card.Title>
              <Card.Text dangerouslySetInnerHTML={{ __html: content }} />
              {category.map(key => {
                return (
                  <p key={key}>
                    <Badge
                      variant='danger'
                      className='text-capitalize float-right mr-2 mb-2'
                    >
                      {key}
                    </Badge>
                  </p>
                )
              })}
            </Card.Body>
          )}
        </Card>
      </Link>
    </Col>
  )
}

CardNews.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  content: PropTypes.string,
  image: PropTypes.string,
  category: PropTypes.array,
  event_start: PropTypes.string,
  event_end: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string
}

CardNews.defaultProps = {
  id: 1,
  title: 'Not set',
  content: 'No set',
  image: imgCard,
  category: ['category', 'not set'],
  event_start: 'Not set',
  event_end: 'Not set',
  type: 'event',
  url: '*'
}
